import React, { PropTypes } from 'react';
import { Table } from '@bibliocommons/base-table';

function MarcHoldingsTable({ rows }) {
  const eResourceMap = resources => (
    <ul>
      {
        resources.map(resource => (
          <li><a href={resource.get('url')}>{resource.get('description')}</a></li>
          ))
        }
    </ul>
    );

  return (
    <Table
      rows={rows}
      fields={[
          { key: 'location' },
          { key: 'collection' },
          { key: 'format', localizationMap: value => (`FORMAT.${value.toLowerCase()}`) },
          { key: 'holdDuration' },
          { key: 'electronicResource', localizationMap: eResourceMap }
      ]} />
  );
}

MarcHoldingsTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired
};


export default MarcHoldingsTable;



// WEBPACK FOOTER //
// ./app/components/shared/MarcHoldingsTable/MarcHoldingsTable.jsx